var map = {
	"./en/lang.js": 21,
	"./zh_CN/lang.js": 22
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 20;



//////////////////
// WEBPACK FOOTER
// ./DeviceNetwork/resources/language ./~/file-loader!^\.\/.*\/lang\.js$
// module id = 20
// module chunks = 52